import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Button, Box } from '@material-ui/core';

import { usePageBallotCopyStyles } from '../styles';
import AppInput from '../../../../common/AppInput';
import AuthorizeCheckbox from '../../../mis-compras/components/report-issue-view/forms/authorizeThird/AuthorizeCheckbox';
import { bodyIssueTicketGenerator } from '../../../../../helpers/tickets/TicketsHelper';
import { createTicketNoProduct } from '../../../../../redux/actions/TicketActions';
import { REQUEST_NOT_PRODUCT_TICKET } from '../../../../../constants/Routes';

const ExtendGiftCard = (props) => {
  const { mobile, motiveId, type } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const [numberCard, setNumberCard] = useState('');
  const [comment, setComment] = useState('');
  const [checked, setChecked] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [helper, setHelper] = useState('0/200');
  const classes = usePageBallotCopyStyles({ mobile });
  const { ticketNoProductStatus } = useSelector(
    (innerState) => innerState.ticketReducer,
  );
  const { profile } = useSelector((state) => state.profileReducer);

  const onChangeNumberCard = (e) => setNumberCard(e.target.value);

  const onChangeComment = (e) => {
    const { value } = e.target;
    if (value.length <= 200) {
      setComment(value);
      setHelper(`${value.length}/200`);
    }
  };

  const onBlurNumberCard = (e) => {
    const { value } = e.target;
    const isNum = /^\d+$/.test(value);
    if (isNum) {
      if (value.length === 7 || value.length === 20) {
        setError(false);
        setSuccess(true);
        setDisabled(false);
      } else {
        setError(true);
        setSuccess(false);
        setDisabled(true);
      }
    } else {
      setError(true);
      setSuccess(false);
      setDisabled(true);
    }
  };

  const concatenateComment = () => `Giftcard: ${numberCard} - ${comment}`;

  const onClickButton = () => {
    const joinComment = concatenateComment();
    const body = bodyIssueTicketGenerator({
      profile,
      type,
      motiveId,
      comment: joinComment,
    });
    dispatch(createTicketNoProduct(body));
  };

  useEffect(() => {
    if (ticketNoProductStatus === 'succeded') {
      setComment('');
      setNumberCard('');
      history.push(REQUEST_NOT_PRODUCT_TICKET);
    }
  }, [ticketNoProductStatus]);

  return (
    <Box
      className={classes.container}
      margin={mobile ? '0px -16px' : '0px 50px'}
      width={mobile ? 'auto' : '75%'}
    >
      <AppInput
        name="orderId"
        required
        helperText={'Ingresa 7 o 20 dígitos'}
        label={'Ingresa el número de tu Gift Card'}
        value={numberCard}
        onClick={() => {}}
        onBlur={onBlurNumberCard}
        onChange={onChangeNumberCard}
        error={error}
        errorMessage={'Ingresa 7 o 20 dígitos'}
        success={success}
      />
      <AppInput
        name="comentario"
        helperText={helper}
        label="Descripción"
        value={comment}
        onClick={() => {}}
        onBlur={() => {}}
        onChange={onChangeComment}
        multiline
      />
      <AuthorizeCheckbox
        idComplement="FormExtendGiftCard"
        disabled={disabled}
        onCheck={() => setChecked(!checked)}
      />
      <div className={classes.contButton}>
        <Button
          className={classes.sendButton}
          variant="contained"
          data-cy="ButtonExtendGiftCard"
          onClick={onClickButton}
          color="primary"
          disabled={!checked || disabled}
        >
          Enviar
        </Button>
      </div>
    </Box>
  );
};

ExtendGiftCard.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.number,
  type: PropTypes.number,
};

export default ExtendGiftCard;
